import { httpRequest } from '@/utils/HttpRequest'
import { getBaseCiRequestUrl, getToken } from '@/utils/constants'
import { IPage } from "@/types/AppTypes";
import {
	IMaintenanceDetail,
	IItemDetailList,
	ThreeGuaranteesItemDetailList,
	IMaterialDetailList,
	OtherItemDetailList
} from './MaintenanceType';

class MaintenanceService {

	async one(id: string) {
		const apiUrl = `/ci/order/platform_one/${id}`;
		return await httpRequest.post<IMaintenanceDetail>(apiUrl, {}, { baseURL: getBaseCiRequestUrl(), token: getToken() })
	}


	async itemList(param: any) {
		const apiUrl = `/ci/order/item/list`;
		return await httpRequest.post<IPage<IItemDetailList>>(apiUrl, param, { baseURL: getBaseCiRequestUrl(), token: getToken() })
	}

	async threeGuaranteesList(param: any) {
		const apiUrl = `/ci/order_three_guarantees/list`;
		return await httpRequest.post<IPage<ThreeGuaranteesItemDetailList>>(apiUrl, param, { baseURL: getBaseCiRequestUrl(), token: getToken() })
	}

	async materialList(param: any) {
		const apiUrl = `/ci/order/maintan-material/list`;
		return await httpRequest.post<IPage<IMaterialDetailList>>(apiUrl, param, { baseURL: getBaseCiRequestUrl(), token: getToken() })
	}

	async otherItemDetailList(param: any) {
		const apiUrl = `/ci/order/other-item/list`;
		return await httpRequest.post<IPage<OtherItemDetailList>>(apiUrl, param, { baseURL: getBaseCiRequestUrl(), token: getToken() })
	}

}
export const maintenanceService = new MaintenanceService();
